import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ metric }) => {
  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up':
        return 'TrendingUp';
      case 'down':
        return 'TrendingDown';
      case 'stable':
        return 'Minus';
      default:
        return 'Minus';
    }
  };

  const getTrendColor = (trend) => {
    switch (trend) {
      case 'up':
        return 'text-success';
      case 'down':
        return 'text-destructive';
      case 'stable':
        return 'text-muted-foreground';
      default:
        return 'text-muted-foreground';
    }
  };

  const getIconColor = (type) => {
    switch (type) {
      case 'engagements':
        return 'text-primary bg-primary/10';
      case 'assessments':
        return 'text-accent bg-accent/10';
      case 'approvals':
        return 'text-warning bg-warning/10';
      case 'documents':
        return 'text-success bg-success/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover-lift shadow-elevation-1 hover:shadow-elevation-2 nav-transition">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getIconColor(metric?.type)}`}>
            <Icon 
              name={metric?.icon} 
              size={20} 
              className="text-current"
            />
          </div>
          <div>
            <div className="text-2xl font-bold text-foreground font-inter">
              {metric?.value}
            </div>
            <div className="text-sm text-muted-foreground">
              {metric?.label}
            </div>
          </div>
        </div>
        
        <div className="flex items-center space-x-1">
          <Icon 
            name={getTrendIcon(metric?.trend)} 
            size={16} 
            className={getTrendColor(metric?.trend)}
          />
          <span className={`text-sm font-medium ${getTrendColor(metric?.trend)}`}>
            {metric?.change}
          </span>
        </div>
      </div>
      {metric?.subtitle && (
        <div className="mt-3 text-xs text-muted-foreground">
          {metric?.subtitle}
        </div>
      )}
    </div>
  );
};

export default MetricsCard;